// Grupo entregue pelo formulário, guardado no aparelho de quem preencheu.
//
// FUN-01 (07/10/2026): a tela de sucesso do /entrar diz "Guarde esta página. O
// link continua valendo", e recarregar apagava o link. O link entregue fica no
// navegador e a tela de "Pronto" volta com ele.
//
// 13/10/2026: de 24 h para 7 dias, e a página de links da bio também lê. A
// casa não chama primeiro quem pegou grupo e não entrou (risco de bloqueio do
// número, decisão do owner); a única recuperação é a pessoa ver o grupo de novo
// quando ela mesma volta. 7 dias é onde 83% dos jogadores que aparecem já
// apareceram (medição do pool, 24/09/2026).
//
// O /entrar e o /links são servidos em www.clubesbrazil.com (rewrite da
// landing), então os dois leem a mesma chave.

export const GRUPO_GUARDADO = 'cb-entrar-grupo'
export const VALIDADE_GUARDADO_MS = 7 * 24 * 60 * 60 * 1000

export type GrupoGuardado = { link: string; nome: string; em: number }

export function lerGrupoGuardado(agoraMs: number = Date.now()): GrupoGuardado | null {
  try {
    const bruto = window.localStorage.getItem(GRUPO_GUARDADO)
    if (!bruto) return null
    const g = JSON.parse(bruto) as Partial<GrupoGuardado>
    if (typeof g.link !== 'string' || typeof g.em !== 'number') return null
    // Só link de convite do WhatsApp vira botão: o valor vem do armazenamento
    // do aparelho, e um "javascript:" ali seria executado no toque.
    if (!g.link.startsWith('https://chat.whatsapp.com/')) return null
    if (agoraMs - g.em > VALIDADE_GUARDADO_MS) return null
    return { link: g.link, nome: typeof g.nome === 'string' ? g.nome : '', em: g.em }
  } catch {
    return null
  }
}

export function guardarGrupo(link: string, nome: string): void {
  try {
    window.localStorage.setItem(GRUPO_GUARDADO, JSON.stringify({ link, nome, em: Date.now() }))
  } catch {
    // Navegador sem armazenamento (aba anônima, bloqueio): o servidor cobre.
  }
}

export function esquecerGrupo(): void {
  try {
    window.localStorage.removeItem(GRUPO_GUARDADO)
  } catch {
    // Sem armazenamento não há o que esquecer.
  }
}

/**
 * Nome do lembrete: até duas palavras do campo Nome (F2-01, aprovado pelo
 * owner em 08/10/2026), para "Ana Paula" não virar só "Ana".
 */
export function nomeDoLembrete(nome: string | null | undefined): string {
  return (nome ?? '').trim().split(/\s+/).filter(Boolean).slice(0, 2).join(' ')
}
